<template>
  <div>
      <div class="page">
        <img v-if="luckDrawState === 2 "  src="../../../assets/pointsActivity/statu-end.png" class="end-img" />
        <van-swipe lazy-render class="swipe" :autoplay="3000">
          <van-swipe-item v-for="image in images" :key="image">
            <img :src="image" class="image"/>
          </van-swipe-item>
        </van-swipe>
        <div class="top-box">
            <div class="activity" @click="openModal"  v-if="allInfo.prizeCurrent?.desc">
              <img src="../../../assets/pointsActivity/detailicon.png" />
              <div class="title">活动说明</div>
            </div>
          </div>
          <div class="buttom-goods" :class="luckDrawState == 8 ? 'get-prize-8' : ''" v-if="!isLoading">
          <div class="luckyDraw" :class="luckDrawState < 7 ? 'box-margin': ''">
            <div v-if="luckDrawState === 2 && (allInfo.prizePoints?.prizeCode === 0 || allInfo.prizePoints == null)" class="lottery-part btn-box">
              <div class="lottery-btn disable">
                <span class="text">{{ '已结束' }}</span>
              </div>
              <div class="time-copy-write text-bottom">当前活动已于 {{ activityState?.endTime || '' }} 结束</div>
            </div>
            <div v-else-if="luckDrawState === 1" class="lottery-part btn-box">
              <div class="time-copy-write text-top">{{ activityState?.startTime || '' }} 开始</div>
              <div class="lottery-btn disable">
                <span class="text">{{ '即将开启' }}</span>
              </div>
            </div>
            <div v-else-if="!token || token == '' || token == undefined" class="lottery-part btn-box">
                <div class="lottery-btn-border"></div>
                <div class="lottery-btn" @click="toPage(orderBtn.url)">
                  <p class="text text-login">{{ '立即登录参与' }}</p>
                </div>
            </div>
            <div v-else-if="luckDrawState === 3" class="lottery-part">
              <div class="btn-list">
                <div class="lottery-btn-before disable">
                  <div class="text">{{ '已参与' }}</div>
                </div>
                <img src="https://cdn-arch-common-prod.cotticoffee.com/cottih5/lottery-no-btn-border-1.png" class="part-border"/>
                <div class="lottery-btn disable">
                  <div class="text1">{{ '已结束' }}</div>
                  <div class="text2">{{ '未达标' }}</div>
                </div>
              </div> 
              <div class="time-copy-write text-bottom">当前活动已于 {{ activityState?.endTime || '' }} 结束</div>
              <div class="text-copy-write">{{ activityState?.noCodeTip }}</div>

            </div>
            <div v-else-if="luckDrawState === 4" class="lottery-part btn-box">
              <div class="lottery-btn-border"></div>
              <div class="lottery-btn"  @click="applyLottery()">
                <div class="text1">{{ '参与抽奖' }}</div>
              </div>
            </div>
            <div v-else-if="luckDrawState === 5" class="lottery-part">
              <div class="btn-list">
                <img src="https://cdn-arch-common-prod.cotticoffee.com/cottih5/lottery-part-2.png" class="part-img"/>
                <img src="https://cdn-arch-common-prod.cotticoffee.com/cottih5/lottery-btn-border-1.png" class="part-border"/>
                  <div class="lottery-btn-border"></div>
                  <div class="lottery-btn" @click="toPage(orderBtn.url)">
                  <div class="text1">{{ '去下单' }}</div>
                </div>
              </div>
            </div>
            <div v-else-if="luckDrawState === 6" class="lottery-part">
              <div class="btn-list">
                <img src="https://cdn-arch-common-prod.cotticoffee.com/cottih5/lottery-part-2.png" class="part-img"/>
                <img src="https://cdn-arch-common-prod.cotticoffee.com/cottih5/lottery-btn-border-1.png" class="part-border"/>
                  <div class="lottery-btn">
                  <div class="text1">{{ '待开奖' }}</div>
                </div>
              </div>
              <div class="time-copy-write text-bottom">{{ allInfo.prizeCurrent?.luckyDraw?.prompt }}</div>
              <div class="luckyDraw" v-if="prizeCodeList.length == 1">
                <div class="body">
                  <div class="text-five">
                    <span class="prize-code-text">抽奖码</span>
                   <div> {{ prizeCodeList[0] }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else-if="luckDrawState === 7" class="lottery-part">
               <div class="luckyDraw">
                <div class="prize-header">
                  <img src="https://cdn-arch-common-prod.cotticoffee.com/cottih5/icon-no-prize-title-left.png" /> 
                  <div class="text">{{ stateDesc || '抱歉，您未中奖' }}</div>
                  <img src="https://cdn-arch-common-prod.cotticoffee.com/cottih5/icon-no-prize-title-right.png" />
                </div> 
                <div class="body" v-if="prizeCodeList.length == 1">
                  <div class="text-seven">
                    <span class="prize-code-text">抽奖码</span>
                   <div> {{ prizeCodeList[0] }}</div>
                  </div>
                </div>
               </div>
            </div>
            <div v-else-if="luckDrawState === 8" class="lottery-part">
               <div class="luckyDraw luckyDraw-6">
                <div class="prize-header">
                  <img src="https://cdn-arch-common-prod.cotticoffee.com/cottih5/icon-title-left.png" /> 
                  <div class="prize-text">{{ stateDesc || '恭喜您中奖啦' }}</div>
                  <img src="https://cdn-arch-common-prod.cotticoffee.com/cottih5/icon-title-right.png" />
                </div> 
                <div class="body"  v-if="prizeCodeList.length == 1">
                  <div class="text-six">
                    <span class="prize-code-text">抽奖码</span>
                    <div>{{ prizeCodeList[0] }}</div>
                    </div>
                </div>
                <div class="card">
                  <img :src="allInfo?.winningPrizeVO?.prizePictureAdPictureUrl"/>
                  <div class="prize">
                    <div class="title"> {{ allInfo?.winningPrizeVO?.prizeName }}</div>
                    <div class="context"> {{ allInfo?.winningPrizeVO?.winningPrompt }}</div>
                  </div>
                </div>
               </div>
            </div>
          </div>
          <div class="activity-tip" v-if="activityState?.orderTip?.tip">
            <div class="text-no-tip">{{ activityState?.orderTip?.noTip }}</div>
            <div class="time-copy-write text-bottom">
                <span v-for="(char, index) in activityState?.orderTip?.tip" :key="index">
                <span v-if="isNumber(char)" :style="{ color: '#A52337', fontWeight: 600 }"  :class="isNumber(activityState?.orderTip?.tip[index - 1]) ? 'num-style-right' : isNumber(activityState?.orderTip?.tip[index + 1]) ? 'num-style-left' :'num-style'">{{ char }}</span>
                <span v-else>{{ char }}</span>
              </span>
            </div>
          </div>
          <!-- <div class="one-lottery-code" v-if="luckDrawState == 6 && prizeCodeList.length == 1">
            <div class="body">
                  <div class="text-seven">
                    <span class="prize-code-text">抽奖码</span>
                   <div> {{ prizeCodeList[0] }}</div>
                  </div>
                </div>
          </div> -->
          <div class="lottery-code" :class="prizeCodeList.length > 6 ? 'more-code' : ''" v-if="(luckDrawState <= 5 && prizeCodeList.length > 0) || (luckDrawState > 5 && prizeCodeList.length > 1)">
            <div class="lottery-title">
              <div class="lottery-code-get">已获得抽奖码（{{ prizeCodeList.length }}）</div>
              <span class="lottery-code-max">每人最多可获得{{prizeCodeCountLimit || ''}}个</span>
            </div>
            <div class="lottery-body">
              <div v-for="(item, index) in prizeCodeList" :key="index" class="lotter-code">
                <div class="lotter-code-num lotter-code-prize-num" v-show="index <= 5 || isExpand" v-if="index == 0 && luckDrawState == 8">
                  <div class="lottery-prize-title">中奖啦</div>
                  <div class="lottery-prize-code">{{ item }}</div>
                  </div>
                <div class="lotter-code-num" :class="luckDrawState >= 7 ? 'lottery-no-code-num': ''" v-show="index <= 5 || isExpand" v-else>{{ item }}</div>
              </div>
              <div class="lotter-code-expand" :class="isExpand ? 'expand' : 'no-expand'" v-if="prizeCodeList.length > 6" @click="expandChange()">{{ isExpand ?  '收起' : '展开更多' }}
                <img v-if="isExpand" src="https://cdn-arch-common-prod.cotticoffee.com/cottih5/icon_lottery_retract.png" /> 
                <img v-else src="https://cdn-arch-common-prod.cotticoffee.com/cottih5/icon_lottery_launch.png" /> 
              </div>
            </div>
          </div>
        </div>
        <!-- <UpComingList :list="upcomingActivityList" :activityNo="allInfo.prizeCurrent.no"/> -->
       
     
      <CottiModal :show="modalStatus" :title="modal.title" :type="modal.type" :desc="modal.desc" :btn-text="modal.btn"
                  @onConfirm="()=>{this.modalStatus=false}" @onClose="()=>{this.modalStatus=false}">
        <slot>
          <div class="lottery-ticket">
            <div class="code">{{ winningCode }}</div>
          </div>
        </slot>
      </CottiModal>
      <!--  兑换  -->
      <CottiModal :show="exchangeModalStatus" :title="exchangeModal.title" :descList="exchangeModal.desc"
                  :btn-text="exchangeModal.btn"
                  @onConfirm="confirmExchange" @onClose="()=>{this.exchangeModalStatus=false}">
        <slot>
          <div class="lottery-Exchang">
            <div class="top">
              <div>您正在使用</div>
              <span>{{ validateData.points }}</span>
              <img src="../../../assets/pointsActivity/xingxing@2x.png">
              <div>兑换</div>
            </div>
            <div class="down">
              {{ validateData.prizeName }}
            </div>
          </div>
        </slot>
      </CottiModal>
      <!--  中奖  -->
      <CottiModal :show="winningDialog" :imgContent="true"
                  @onClose="()=>{this.winningDialog=false;this.winningFalsh = false}">
        <slot>
          <img :src="winningDialogImg" class="adImgSize">
          <div class="bottom-gif" v-if="winningFalsh">
            <img src="../../../assets/pointsActivity/winningAnimation.gif">
          </div>
        </slot>
      </CottiModal>

    </div>
    <van-popup v-model="popupVisible" position="bottom">
    <div class="popup-content">
      <div class="popup-tit">
        活动说明
        <van-icon name="cross" @click="hidePopup"/>
      </div>
      <div class="popup-text">
        <p>{{ allInfo.prizeCurrent?.desc }}</p>
      </div>
      <div class="popup-btn" @click="hidePopup">我知道了</div>
    </div>
  </van-popup>
  </div>
</template>


<script>
// import UpComingList from '@/views/lotteryActivity/components/upComingList'
import Prize from "@/views/pointsActivity/components/prize";
import CottiModal from '../../../components/modal'
import {
  getDialogAdInfo,
  getExchangeData,
  getPointsActivityInfo,
  getPointsDetails,
  getValidateData,
  prizeList,
  submitLotteryWishForce,
  updateFrequency
} from "@/api/pointsActivity";
import Winning from "@/views/pointsActivity/components/winning";
import Exchange from "@/views/pointsActivity/components/exchange";
import Calendar from "@/views/pointsActivity/components/calendar";
import wx from "weixin-js-sdk";
import { isWeixin, formatDateToMDHMS } from "@/utils";

export default {
  name: "history",
  components: {Prize, Winning, Exchange, CottiModal, Calendar},
  props: {
    activityNoHistory: {
      type: String,
      default:''
    },
  },
  watch:{
    activityNoHistory(val){
      console.log(val, 'val')
      this.activityNo = val
    }
  },
  data() {
    return {
      historyData: [],
      upcomingActivityList: [],
      activityState: {},
      startTime: null,
      pointsStartTime: null,
      endTime: null,
      maxStartTime: null,
      prizeCodeCountLimit: null,
      // 抽奖码
      prizeCodeList: [],
      //日历数据
      calendarData: [],
      winningDialog: false,
      winningFalsh: false,
      winningDialogImg: '',
      WinningLotteryData: [],
      // 中奖数据存放
      prizeData: [],
      // 是否能兑换
      exchangeStatus: false,
      bannarUrl: '',
      drawPicUrl: null,
      winningCode: null,
      luckDrawState: 0, // 0 没有资格，1有资格
      // 是否展示抽奖部分
      showLotteryDraw: undefined,
      endtime: undefined,  //活动结束时间
      todaytime: undefined,  //当前时间
      // 未使用积分
      pointsRemaining: 0,
      // 是否显示积分栏
      isShowAvailablePoints: true,
      // 引导文案可用积分栏
      AvailablePoints: '',
      // 判断下单引导栏下单按钮
      orderBtn: {},
      // 判断下单引导栏
      Product: '',
      // 判断是否当前活动积分周期
      cycle: false,
      // 判断当天未完成消费积分
      consumption: false,
      linkTerminal: undefined,
      memberId: 0,
      memberMobile: undefined,
      activityNo: undefined,
      popupVisible: false,
      allInfo: {},
      isLoading: false,
      token: undefined,
      btnLoading: false,
      modalStatus: false,
      buttonDesc: '',
      stateDesc: '',
      images: [],
      // popupVisible: false,
      modal: {
        title: '',
        desc1: '',
        desc2: '',
        btn: '我知道了',
        type: 0
      },
      exchangeModalStatus: false,
      exchangeModal: {
        title: '兑换确认',
        desc: '',
        btn: '确认兑换',
      },
      validateData: {},
      currentItem: {},
      prizeStatus: -1,
      //活动是否结束
      isActivityEnd:false
    }
  },
  async mounted() {
    let {linkTerminal, memberId, contact_id, u_t} = this.$route.query
    if (contact_id !== undefined || memberId !== undefined) {
      this.memberId = !u_t ? (linkTerminal == 3 ? memberId : linkTerminal == 2 ? contact_id : (contact_id || memberId)) : undefined
    }
    this.token = u_t
    this.linkTerminal = linkTerminal
    this.activityNo = this.activityNoHistory
    await this.getInfo()
    // await this.getHistoryList()
  },
  methods: {
    isNumber(char) {
      return /[0-9]/.test(char);
    },
    // closeModel(){
    //   this.popupVisible = false;
    // },
    async getInfo() {
      let {memberId, activityNo, token} = this
      this.isLoading = true;
      this.exchangeStatus = false
      await getPointsActivityInfo({memberId, activityNo}, {token}).then((res) => {
        if (res.code == 200) {
          this.allInfo = res.data
          this.prizeCodeCountLimit = res.data.prizeCurrent?.luckyDraw?.prizeCodeCountLimit || null
          this.activityState = res.data.activityState
          if (this.activityState?.orderTip?.tip?.includes('\n')) {
            this.activityState.orderTip.noTip = this.activityState.orderTip.tip.split('\n')[0]
            this.activityState.orderTip.tip = this.activityState.orderTip.tip.split('\n')[1]
          }
          if (this.activityState.startTime) {
            this.activityState.startTime = formatDateToMDHMS(this.activityState?.startTime, 1)
          }
          if (this.activityState.endTime) {
            this.activityState.endTime = formatDateToMDHMS(this.activityState?.endTime, 1)
          }
          if (this.activityState?.startTime.includes('00:00')) {
            this.activityState.startTime = this.activityState.startTime.replace(' 00:00','')
          }
          if (this.activityState?.endTime.includes('00:00')) {
            this.activityState.endTime = this.activityState.endTime.replace(' 00:00','')
          }
         
          this.prizeCodeList = res.data.prizeCodeList
          this.upcomingActivityList = res.data.upcomingActivityList || []
          /* 我中奖的 */
          if (res.data.prizePoints?.winningStatus == 1) {
            this.WinningLotteryData = res.data.prizeCurrent?.luckyDraw?.lotteryPrizes.filter(f => f.prizeType == res.data.prizePoints.winningType)
          }

          //获取我兑换的奖品
          this.getPrizeData()

          /*  判断是否当前活动积分周期  */
          let date = new Date();
          let startTime = Date.parse(new Date(res.data?.prizeCurrent?.pointsStartTime.replaceAll("-", "/")).toString());    // 活动开始时间
          let endTime = Date.parse(new Date(res.data?.prizeCurrent?.pointsEndTime.replaceAll("-", "/")).toString());       // 活动结束时间
          let currentTime = date.getTime()  //当前时间
          if (currentTime <= endTime && currentTime >= startTime) {
            this.cycle = true
          }

          let activityEndTime = Date.parse(new Date(res.data?.prizeCurrent?.activityEndTime.replaceAll("-", "/")).toString());
          if(currentTime > activityEndTime){
            this.isActivityEnd = true
          }

          getPointsDetails({memberId, activityNo}, {token}).then(detail => {
            this.calendarData = detail.data || []
            /*  判断当天未完成消费积分 */
            let today = date.toLocaleDateString('zh', {
              year: 'numeric', month: '2-digit',
              day: '2-digit'
            })  // 获取当天日期
            let todayConsumption = detail.data.filter(item => item.orderTime.replaceAll("-", "/").split(" ")[0] == today)   //过滤数组 获取当前日期
            if (todayConsumption && todayConsumption.length > 0) {
              this.consumption = todayConsumption[0].points == 0 ? true : false
            }
            if (detail.data.length <= 0) {
              this.consumption = false
            }
          })


          /*  下单引导栏  */
          let isAllProduct = res.data.prizeCurrent?.isAllProduct  //商品
          let shopNotInRules = res.data.prizeCurrent?.shopNotInRules   //门店
          if (isAllProduct && shopNotInRules.length <= 0) {
            //任意门店消费任意商品即可攒星
            this.Product = res.data.prizeCurrent.orderGuidance.content.noShopAndProduct
          } else if (isAllProduct && shopNotInRules.length > 0) {
            //指定门店消费任意商品即可攒星
            this.Product = res.data.prizeCurrent.orderGuidance.content.shopAndProduct
          } else if (!isAllProduct && shopNotInRules.length <= 0) {
            //任意门店消费指定商品即可攒星
            this.Product = res.data.prizeCurrent.orderGuidance.content.noShopAndNoProduct
          } else if (!isAllProduct && shopNotInRules.length > 0) {
            //指定门店消费指定商品即可攒星
            this.Product = res.data.prizeCurrent.orderGuidance.content.shopAndNoProduct
          }

          /*  下单引导栏按钮  */
          if (this.token == undefined || this.token == null || this.token == '') {
            this.isLogin = false
            // undefined 是用户未登录状态小程序
            this.Product = '登录后可查看攒星详情及兑换周边'
            this.allInfo.prizeCurrent.orderGuidance.title = '您尚未登录'
            if (this.linkTerminal == 3) {
              this.orderBtn = {
                title: '立即登录',
                url: ''
              }
            } else {
              this.orderBtn = {
                title: '立即登录',
                url: 'packages/common/login/index'
              }
            }
          } else {
             if (this.linkTerminal == 3) {
              this.orderBtn.title = res.data.prizeCurrent?.orderGuidance?.button?.app?.title
              this.orderBtn.url = res.data.prizeCurrent?.orderGuidance.button.app.url
            } else {
              this.orderBtn.title = res.data.prizeCurrent?.orderGuidance?.button.wechat?.title
              this.orderBtn.url = res.data.prizeCurrent?.orderGuidance.button.wechat.url
            }
          }

          /* 抽奖内容 */
          this.showLotteryDraw = res.data.prizeCurrent.luckyDraw.status
          this.winningCode = res.data.prizePoints?.prizeCode | ''
          this.luckDrawState = res.data.state;
          console.log(this.luckDrawState, res.data.state)
          this.drawPicUrl = res.data.prizeCurrent.luckyDraw.adInfo?.pictureUrl || res.data.prizeCurrent.luckyDraw.adInfo?.conditionMap.positionResourceFile1[0].value
          this.images = res.data.defaultBannerAdPictureUrls
          this.bannarUrl = res.data.prizeCurrent?.defaultBanner.adInfo?.pictureUrl || res.data.prizeCurrent?.defaultBanner.adInfo?.conditionMap.positionResourceFile1[0].value
          
          this.buttonDesc = res.data.buttonDesc
          this.stateDesc = res.data.stateDesc
          /* 判断抽奖状态展示 */
          if (res.data.prizeCurrent.luckyDraw && res.data.prizeCurrent.luckyDraw.status) {
            if (res.data.prizePoints) {
              this.getLuckyDrawStatus(res.data.prizePoints);
            }
          }

          /*  引导文案可用积分栏  */
          let minPoints = res.data.minPoints       //最小梯度奖品积分
          this.pointsRemaining = res.data.prizePoints ? res.data.prizePoints?.pointsRemaining || 0 : 0    //未使用积分数值
          let temporarily = minPoints - this.pointsRemaining    //未使用积分数值
          this.endtime = new Date(res.data.prizeCurrent?.activityEndTime.replaceAll("-", "/")).getTime()   //活动结束时间
          let pointsStartTime = new Date(res.data.prizeCurrent?.pointsEndTime.replaceAll("-", "/")).getTime()   //积分结束时间
          this.todaytime = new Date().getTime()      //当前时间


          if (minPoints > this.pointsRemaining && this.todaytime <= pointsStartTime) {
            this.AvailablePoints = `再消费 <span>${temporarily}</span> 杯即可兑换库迪周边`
          } else if (this.todaytime <= this.endtime && this.pointsRemaining >= minPoints) {
            let activittime = res.data.prizeCurrent?.activityEndTime.split(" ")[0]
            let endYear = new Date(activittime).getFullYear()
            if (new Date().getFullYear() == endYear) {
              activittime = activittime.split("-").slice(1, 3).join("-")
            }
            this.AvailablePoints = `请于 <span>${activittime}</span> 前兑换使用`
            this.exchangeStatus = true
          } else if (this.todaytime > this.endtime && this.pointsRemaining > 0) {
            this.AvailablePoints = '过期未使用'
          } else if (this.todaytime > this.endtime && this.pointsRemaining == 0) {
            this.isShowAvailablePoints = false
          } else {
            this.AvailablePoints = ''
          }
          if (res.data.winningPrizeVO?.winningPopupAdPictureUrl) {
            this.winningDialogImg = res.data.winningPrizeVO?.winningPopupAdPictureUrl
            this.winningDialog = true
            this.winningFalsh = true
            setTimeout(() => {
              this.winningFalsh = false
            }, 2000)
            updateFrequency({
            did,
            code,
            positionCode: res.data.winningPrizeVO?.winningPopupAdPositionCode
          })
          }
        }
      }).finally(() => {
        this.isLoading = false;
        if ((!this.token || this.token == '' || this.token == undefined) && this.luckDrawState > 2) {
          this.getBuryingPointsData("mkt_points_lottery_login_show")
        }
        if (this.luckDrawState == 5) {
          this.getBuryingPointsData("mkt_points_lottery_order_show")
        }
        this.getBuryingPointsData("mkt_points_page_view");
      })
    },
    async getDialogAdDetail(did, code) {
      await getDialogAdInfo({
        did,
        code,
        viewPage: 'cotti-app-home'
      }).then(res => {
        if (res.code == 200 && res.data.length > 0) {
          let adInfo = res.data[0]
          this.winningDialogImg = adInfo.url
          this.winningDialog = true
          this.winningFalsh = true
          setTimeout(() => {
            this.winningFalsh = false
          }, 2000)
          updateFrequency({
            did,
            code,
            positionCode: adInfo.positionCode
          })
        }
      })
    },
    getLuckyDrawStatus(userPoint) {
      if (userPoint) {
        let {prizeStatus, prizeCode, winningStatus} = userPoint
        //未参与抽奖
        if (prizeStatus == 0 || prizeStatus == null) {
          this.prizeStatus = 0
        } else if (winningStatus == 1) {
          //中奖
          this.prizeStatus = 3
        } else if (prizeStatus == 1 && prizeCode != null && this.luckDrawState != 2) {
          //待抽奖
          this.prizeStatus = 1
        } else if ((winningStatus == 0 || winningStatus == null) && prizeStatus == 1 && this.luckDrawState == 2) {
          //未中奖
          this.prizeStatus = 2
        }
      }
    },
    // 获取埋点对象
    getBuryingPointsData(code) {
      if (!this.allInfo.prizePoints) {
        return false;
      }
      let {id: activity_id} = this.allInfo?.prizeCurrent;
      let {
        memberId: member_id,
        prizeStatus: prize_status,
        points: current_points,
        winningStatus: winning_status
      } = this.allInfo.prizePoints;
      // 埋点
      this.$sensors.track(code, {
        //活动ID
        activity_id,
        // 会员编号
        member_id,
        //是否抽奖 0-未抽奖 1-已抽奖
        prize_status,
        // 当前星值
        current_points,
        // 是否中奖 0-未中奖 1-已中奖
        winning_status,
        // 当前兑换礼品数
        current_exchange_num: this.prizeData.length,
        // 当前抽奖码数量
        current_prize_code_num: this.prizeCodeList.length,
      });
    },
    async applyLottery() {
      if (this.btnLoading) {
        return
      }
      try {
        this.btnLoading = true
        let {memberId, token} = this
        const res = await submitLotteryWishForce({
          activityId: this.allInfo?.prizeCurrent?.id,
          memberId
        }, {token})
        if (res.busCode !== '1') {
          this.$toast(res.busMessage);
        }
        if (res.code == 200) {
          this.winningCode = res.data.prizeCode
          if (res.data.prizeCodeCount == 0) {
            if(res.data.prizeCodeCountLimit == 1) {
              this.modalStatus = true
              this.modal = {
                title: '您还不具备抽奖资格',
                desc1: res.data.requiredPoints == 1 ? '活动期间每消费任意饮品' : '活动期间每消费任意' + res.data.requiredPoints +  '杯饮品',
                desc2: '自动获得' + '抽奖码',
                btn: '我知道了',
                type: 0
              }
            } else {
              this.modalStatus = true
              this.modal = {
                title: '您还不具备抽奖资格',
                desc1: '活动期间每买' + res.data.requiredPoints +  '杯，得1个抽奖码',
                desc2: '最多可得' + res.data.prizeCodeCountLimit + '个',
                btn: '我知道了',
                type: 0
              }
            }
          } else {
            if(res.data.prizeCodeCountLimit == 1) {
              this.modalStatus = true
              this.modal = {
                title: '参与成功',
                desc1: '已自动统计您在活动期间的订单',
                desc2: '为您生成抽奖码',
                btn: '好的',
                type: 1
              }
            } else {
              this.modalStatus = true
              this.modal = {
                title: '参与成功',
                desc1: '已自动统计您在活动期间的订单',
                desc2: '为您生成' + res.data.prizeCodeCount + '个抽奖码',
                btn: '好的',
                type: 1
              }
            }
          }
          await this.getInfo()
          this.getBuryingPointsData("mkt_points_lottery_draw")
          this.getPopupPointData('mkt_points_lottery_succeed_popup', this.modal.type)
          if (res.data.msg) {
            // this.modalStatus = true
            // this.$set(this.modal, 'desc', res.data.msg)
            this.allInfo.prizePoints.prizeCode = this.winningCode
          }
        }
        console.log('submitLotteryWish', res)
      } catch (e) {
        console.warn('submitLotteryWish error', e)
      } finally {
        this.btnLoading = false
      }
    },
    async getPrizeData() {
      let {memberId, token} = this
      let activityId = this.allInfo?.prizeCurrent?.id
      let adPrefix = this.allInfo?.prizeCurrent?.adPrefix
      prizeList({memberId, activityId, adPrefix}, {token}).then((res) => {
        if (res.code == 200) {
          this.prizeData = res.data ? res.data : [];
        }
      })
    },
    getPopupPointData(code, type) {
      let {id: activity_id} = this.allInfo?.prizeCurrent;
      let {
        memberId: member_id,
        prizeStatus: prize_status,
        pointsRemaining: current_points,
        winningStatus: winning_status
      } = this.allInfo.prizePoints;
      // 埋点
      this.$sensors.track(code, {
        //活动ID
        activity_id,
        // 会员编号
        member_id,
        //是否抽奖 0-未抽奖 1-已抽奖
        prize_status,
        // 当前星值
        current_points,
        // 是否中奖 0-未中奖 1-已中奖
        winning_status,
        // 当前兑换礼品数
        current_exchange_num: this.prizeData.length,
        // 当前抽奖码数量
        current_prize_code_num: this.prizeCodeList.length,
        //  当前积分
        current_point_num: this.activityState?.orderTip?.p,
        // 弹窗类型
        popup_type: type
      });
    },
    async getHistoryList() {
      let activityNo = this.allInfo.prizeCurrent.no
      let memberId = this.memberId
      getHistory({activityNo, memberId}).then((res) => {
        if (res.code == 200) {
          this.historyData = res.data
        }
      })
    },
    getExchange(item) {
      if (this.pointsRemaining < item.requiredPoints) {
        this.$toast('星值不足，再攒攒吧~');
      } else if (this.todaytime > this.endtime) {
        this.$toast('已过兑换截止时间');
      } else if (this.pointsRemaining >= item.requiredPoints) {
        if (this.todaytime < new Date('2023/06/10 00:00:00').getTime()) {
          this.$toast('6月10日开启兑换哦');
        } else {
          this.currentItem = item
          let activityNo = this.allInfo.prizeCurrent.no
          getValidateData({activityNo, templateNo: item.templateNo}).then((res) => {
            this.exchangeModalStatus = true
            if (res.code == 200 && res.busCode == 1) {
              this.validateData = res.data
              this.exchangeModal.desc = `兑换成功后，您的账户将到账 1 张「${res.data.couponName}」`
            } else {
              this.exchangeModalStatus = false
              this.$toast(res.busMessage)
            }
          })
        }
      }
    },
    toPage(url) {
      if (!this.token || this.token == '' || this.token == undefined) {
        this.getBuryingPointsData("mkt_points_lottery_login_click")
      }
      if (this.luckDrawState == 5) {
        this.getBuryingPointsData("mkt_points_lottery_order_click")
      }
      if (this.linkTerminal == 3) {
        if (this.token == undefined || this.token == null || this.token == '') {
          try {
            const data = ''
            NavigationLogin.postMessage(data)
          } catch (e) {
            console.warn('NavigationLogin is error')
            console.warn(e)
          }
        } else {
          const data = `{"path":"${url}"}`;
          CottiNavigation.postMessage(data);
        }
      } else {
        if (isWeixin()) {
          let pathList = [
              "pages/index/index",
              "pages/purchase/index",
              "pages/order/index",
              "pages/mine/index"
            ];
            if (pathList.includes(url)) {
              wx.miniProgram.switchTab({
                url: `/${url}`,
                success: function (res) {
                  console.log('success res=', res)
                },
                fail: function (res) {
                  console.log('fail res=', res)
                }
              });
            }  else {
              wx.miniProgram.navigateTo({
                url: `/${url}`,
              });
            }
          // wx.miniProgram.navigateTo({
          //   url: `/${url}`,
          // });
        } else {

            let pathList = [
              "pages/index/index",
              "pages/purchase/index",
              "pages/order/index",
              "pages/mine/index"
            ];
            if (pathList.includes(url)) {
              my.switchTab({
                url: `/${url}`,
                success: function (res) {
                  console.log('success res=', res)
                },
                fail: function (res) {
                  console.log('fail res=', res)
                }
              });
            } else {
              my.navigateTo({
              url: `/${url}`,
              success: function (res) {
                console.log(res, '成功');
              },
              fail: function (err) {
                console.log(err);
              }
            });
            }
        //   console.log(this.linkTerminal, 'this.linkTerminal == 4')
        //   my.navigateTo({
        //       url: `/${url}`,
        //       success: function (res) {
        //         console.log(res, '成功');
        //       },
        //       fail: function (err) {
        //         console.log(err);
        //       }
        //     });
        }
      }
    },
    confirmExchange() {
      let activityNo = this.allInfo.prizeCurrent.no
      let templateNo = this.currentItem.templateNo
      let identification = this.validateData.identification
      getExchangeData({activityNo, templateNo, identification}).then((res) => {
        if (res.code == 200 && res.busCode == 1) {
          this.$toast.success('兑换成功')
          this.exchangeModalStatus = false
          this.getInfo()
        } else {
          this.$toast(res.busMessage)
          this.getInfo()
        }
      })
    },
    toHistoryDetail(val) {
      console.log(val)
    },
    lotteryDraw() {
      if (this.linkTerminal == 3) {
        const data = `{"path":"${this.allInfo.prizeCurrent.luckyDraw.adInfo.conditionMap.url_3_1[0].value}"}`;
        CottiNavigation.postMessage(data);
      } else if (this.linkTerminal == 2 || this.linkTerminal == undefined) {
        wx.miniProgram.navigateTo({
          url: `/${this.allInfo.prizeCurrent.luckyDraw.adInfo.conditionMap.url_4_1[0].value}`,
        });
      }
    },
    openModal() {
      this.popupVisible = true
      this.getBuryingPointsData("mkt_points_page_declare_click")
    },
    hidePopup() {
      this.popupVisible = false
    }
  },
}
</script>

<style lang="scss" scoped>
@import "~@/font/D-DIN-PRO/dDinPro500.css";
::v-deep .van-swipe__indicator--active {
    background-color: #FFFFFF;
    opacity: 1;
}
::v-deep .van-swipe__indicators {
    bottom: 24px !important;
}
::v-deep .van-popup {
    background-color: #f5f6f7;
}
.bottom-gif {
  width: 100%;
  height: auto;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  overflow: hidden;
  display: flex;
  align-items: flex-end;
  justify-content: center;

  img {
    width: 100%;
    height: auto;
    display: block;
    pointer-events:none;
  }
}
.van-popup--bottom {
    border-radius: 24px 24px 0 0;

    .popup-content {
      width: 100%;
      height: 100%;

      .popup-tit {
        position: relative;
        text-align: center;
        line-height: 96px;
        height: 96px;
        color: #3A3B3C;
        font-size: 32px;
        font-weight: bold;
      }

      .van-icon-cross {
        position: absolute;
        right: 24px;
        top: 25px;
        font-size: 36px;
      }

      .popup-text {
        //width: calc(100% - 96px);
        padding: 0 32px;
        line-height: 40px;
        margin: auto;
        max-height: 900px;
        overflow: auto;

        p {
          margin-top: 16px;
          font-size: 26px;
          white-space: pre-wrap;
          color: #3A3B3C;
        }
      }

      .popup-btn {
        width: calc(100% - 64px);
        margin: 0 auto;
        margin-top: 16px;
        margin-bottom: 48px;
        line-height: 96px;
        background: linear-gradient( 153deg, #FF7673 0%, #FF3D3D 100%);
        border-radius: 8px;
        color: #FFFFFF;
        font-weight: bold;
        font-size: 32px;
        text-align: center;
        border-radius: 48px;
      }
    }
  }

.page {
  width: 100%;
  padding-bottom: 24px;
  background: #F5F6F7;
  position: relative;
  border-radius: 24px 24px 0 0;
  padding-top: 96px;
  .end-img {
    position: absolute;
    top:136px;
    left:56px;
    width: 144px;
    z-index: 99;
  }
  .top-box {
    // z-index: 9999;
    // padding: 0px 50px 72px 52px;
    // width: calc(100% - 100px);
    position: absolute;
    top: 140px;
    right: 60px;
    .activity {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 48px;
          width: 148px;
          line-height: 48px;
          text-align: center;
          background: rgba(0,0,0, 0.6);
          border-radius: 28px;
          font-size: 20px;
          font-weight: 500;
          color: #FFFFFF;
          z-index: 1;
          font-family: PingFangSC-Medium, PingFang SC;
          float: right;
          margin-right: -30px;

          img{
            width: 26px;
            height: 26px;
            margin: 0 6px 0 -2px;
            pointer-events:none;
          }
        }

  }
  .swipe {
    width: 100%;
    .image {
      width: 100%;
      pointer-events:none;
    }
  }


  .top-poster {
    position: relative;
    width: 100%;

    .banner {
      width: 100%;
      display: block;
    }

    .activity {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 48px;
      right: 40px;
      width: 148px;
      line-height: 48px;
      color: #fff;
      font-size: 20px;
      text-align: center;
      border-radius: 28px;
      background: rgba(58, 59, 60, 0.3);

      img {
        width: 22px;
        height: 22px;
        margin-right: 4px;
      }
      .title {
        font-size: 20px;
      }
    }

  }

  .center-prompt {
    position: relative;
    width: calc(100% - 48px);
    margin: 24px auto;
    margin-bottom: 0;
    top: 0;
    left: 0;

    img {
      display: block;
      width: 100%;
      box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.08);
      border-radius: 8px;
    }

    .prompt-tip {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: absolute;
      top: 0;
      left: 0;
      padding: 24px;
      width: calc(100% - 48px);
      height: calc(100% - 48px);

      .left {
        color: #FFFFFF;
        //font-family: PingFangSC-Medium, PingFang SC;

        div:first-child {
          font-size: 30px;
          font-weight: 500;
        }

        div:last-child {
          font-size: 22px;
          margin-top: 8px;
          font-weight: 500;
        }
      }

      .right {
        display: flex;
        align-items: center;
        color: #fff;
        font-size: 24px;
        font-weight: 500;

        img {
          width: 24px;
          height: 24px;
          margin-left: 10px;
        }
      }
    }

  }
  .get-prize-8 {
      background: linear-gradient(180deg, #FFE8EA 0%, #FFF4F5 62%, #FFFFFF 72%, #FFFFFF 100%) !important;
  }

  .buttom-goods {
    background: #FFFFFF;
      margin: 24px;
      border-radius: 8px;
      padding:0 0 40px 0;
      .activity-tip {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 40px 0 0 0;
        .time-copy-write {
          font-weight: 400;
          font-size: 24px;
          color: #3A3B3C;
          line-height: 32px;
          text-align: center;
          .num-style {
            margin: 0 8px;
          }
          .num-style-left {
            margin: 0 0 0 8px;
          }
          .num-style-right {
            margin: 0 8px 0 0;
          }
        }
        .text-no-tip {
          font-weight: 600;
          font-size: 26px;
          color: #3A3B3C;
          line-height: 32px;
          text-align: center;
        }
        .text-bottom {
          margin-top: 16px;;
        }
      }
      .more-code {
        margin-bottom: -40px;
      }
      .lottery-code {
        margin-top: 32px;
        margin-left: 16px;
        .lottery-title {
          display: flex;
          flex-direction: row;
          margin-left: 8px;
          .lottery-code-get {
            font-weight: 600;
            font-size: 24px;
            color: #3A3B3C;
            line-height: 34px;
            text-align: left;
          }
          .lottery-code-max {
            font-weight: 400;
            font-size: 20px;
            color: #ACACAC;
            line-height: 35px;
            text-align: left;
            margin-left: 6px;
          }
        }
        .lottery-body {
          margin-top: 16px;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          justify-content: flex-start;
          margin-bottom: -8px;
          .lotter-code{
            .lotter-code-num{
              text-align: center;
              display: flex;
              justify-content: center;
              align-items: center;
              width: 208px;
              height: 80px;
              font-size: 36px;
              margin: 8px;
              font-family: "D-DIN-PRO-500-Medium";
              background-size: 100% 100%;
              color: #A52337;
              background-image: url("https://cdn-arch-common-prod.cotticoffee.com/cottih5/lottery-code-list.png");
            }
            .lottery-no-code-num {
              color: #ACACAC;
              background-image: url("https://cdn-arch-common-prod.cotticoffee.com/cottih5/lottery-no-code-list.png");
            }
            .lotter-code-prize-num {
              text-align: center;
              color: #FFFFFF;
              background-image: url("https://cdn-arch-common-prod.cotticoffee.com/cottih5/lottery-prize-code-list.png");
              .lottery-prize-title {
                margin-top: -73px;
                margin-left: -44px;
                width: 64px;
                height: 24px;
                background: linear-gradient( 134deg, #FF9A24 0%, #FF4E1A 100%);
                border-radius: 4px 2px 4px 0px;
                font-weight: 500;
                font-size: 16px;
                color: #FFFFFF;
                line-height: 26px;
                text-align: center;
              }
              .lottery-prize-code {
                margin-left: -19px;
                margin-top: 2px;
              }
            }
          }
          .lotter-code-expand {
            width: 100vh;
            height: 56px;
            line-height: 56px;
            background: rgba(255,255,255,0.8);
            filter: blur(0px);
            // margin-top: -30px;
            text-align: center;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            img {
              width: 24px;
              height: 24px;
              margin-left: 4px;
            }
          }
          .expand {
            font-weight: 600;
            font-size: 22px;
            color: #5E5E5E;
            line-height: 54px;
            height: 56px;
            margin-top: 8px;
          }
          .no-expand{
            margin-top: -30px;
            // padding-top: 12px;
            font-weight: 600;
            font-size: 22px;
            color: #5E5E5E;
            line-height: 54px;
            height: 56px;
          }
          

        }
      }

    .integral {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;

      .balance {
        display: flex;
        flex-flow: wrap;
        flex: 1;
        align-items: baseline;
        font-size: 24px;
        line-height: 50px;
        color: #3C3C3C;
        //height: 56px;

        .num {
          position: relative;
          font-family: "D-DIN-PRO-500-Medium";
          font-size: 56px;
          color: #A52337;
          padding-right: 48px;

          img {
            position: absolute;
            vertical-align: bottom;
            width: 32px;
            height: 32px;
            margin-left: 6px;
            bottom: 2px;
          }
        }

        .text {
          display: flex;
          align-items: flex-end;
          font-size: 22px;
          color: #5E5E5E;
          font-weight: 500;
          font-family: "D-DIN-PRO-500-Medium";

          ::v-deep span {
            color: #A52337;
            font-size: 28px;
            margin: 0 4px 1px 4px;
          }
        }
      }

    }

    .line {
      display: flex;
      align-items: center;
      font-weight: 500;
      color: #5E5E5E;
      font-size: 24px;
      width: 100%;
      margin: 8px 0 32px 0;

      div {
        font-weight: bold;
        color: #5E5E5E;
      }

      span {
        flex: 1;
        color: #EEEEEE;
        width: 50%;
        height: 1px;
        background: #EEEEEE;
      }

      div {
        margin: 0 24px;
      }
    }

    .prize {
      display: flex;
      align-items: center;
      font-size: 24px;
      font-weight: 500;
      color: #3A3B3C;
      margin: 8px 0 8px 0;
      justify-content: space-between;

      img {
        width: 32px;
        height: 32px;
        margin-right: 4px;
        vertical-align: text-bottom;
        pointer-events:none;
      }

      .text {
        font-size: 22px;
        color: #5E5E5E;
        margin-left: 8px;

        ::v-deep span {
          color: #A52337;
          font-size: 28px;
        }
      }

      .left-title {
        display: flex;
        font-size: 28px;
        align-items: center;
        font-family: "D-DIN-PRO-500-Medium";

        span {
          margin: 0 4px;
        }

        .meexchange {
          margin: 5px 0 0 4px;
        }

        .exchange-icon {
          width: 26px;
          height: 26px;
        }

        .titsty {
          margin-top: 3px;
        }

        .titsty-start{
          margin-top: 2px;
        }
      }

      .textFlex {
        align-items: flex-end;
      }

      .more {
        display: flex;
        align-items: center;
        color: #5E5E5E;
        font-size: 24px;

        img {
          width: 32px;
        }
      }
    }

    .tip {
      color: #3A3B3C;
      padding: 0 20px;
      height: 56px;
      line-height: 56px;
      text-align: center;
      font-size: 22px;
      font-weight: 500;
      background: #F5F6F7;
      border-radius: 28px;
      font-family: "D-DIN-PRO-500-Medium";

      span {
        font-size: 28px;
        color: #A52337;
        margin: 0 4px;
      }

      img {
        vertical-align: sub;
        width: 32px;
        height: 32px;
      }
    }

    .box-margin {
      padding-top: 44px;
    }
    .luckyDraw {
      img {
        border-radius: 8px;
        width: 100%;
        height: auto;
        display: block;
      }

      .notSatisfied {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 108px;
        font-size: 32px;
        color: #979797;
        font-weight: 500;
        background: #F5F6F7;
        border-radius: 0 0 8px 8px;
      }

      .logout {
        text-align: center;
        margin-top: 40px;
        .login-button {
          width: 272px;
          height: 96px;
          background: linear-gradient(90deg, #F25757 0%, #A52337 100%);
          box-shadow: 0px 24px 48px 0px #FFB1B11F;
          border-radius: 62px;
          border-color: #FFFFFF;
          border:none !important;
          font-size: 36px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 50px;
        }
      }

      .lotteryCode {
        width: 100%;
        text-align: center;
        font-size: 32px;
        color: #979797;
        font-weight: 500;
        background: #F5F6F7;
        border-radius: 0 0 8px 8px;
        padding-bottom: 40px;

        .text {
          padding: 24px 0;
        }

        .cardbox {
          width: 100%;
          position: relative;

          img {
            display: block;
            margin: auto;
            height: 124px;
            width: 300px;
          }

          span {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: #A52337;
            font-size: 56px;
          }
        }
      }
      .btn-box {
        justify-content: center;
        align-items: center;
      }

      .lottery-part {
        position: relative;
        // padding: 18px 24px 24px 24px;
        // background: #F5F6F7;
        border-radius: 0 0 16px 16px;
        display: flex;
        flex-direction: column;
        .time-copy-write {
          font-weight: 600;
          font-size: 26px;
          color: #3A3B3C;
          line-height: 32px;
          text-align: center;
        }
        .text-copy-write {
          font-weight: 400;
          font-size: 24px;
          color: #ACACAC;
          line-height: 32px;
          text-align: center;
          margin-top: 16px;
        }
        .text-top {
          margin-bottom: 40px;
        }
        .text-bottom {
          margin-top: 40px;
        }
        .btn-list {
          display: flex;
          flex-direction: row;
          align-items: center;
          .part-img{
            // opacity: 0.6;
            width: 128px;
            margin-left: 18px;
          }
          .part-no-img{
            width: 126px;
            // margin-left: -25px;
          }
          .part-border {
            height: 4px;
            width: 84px;
            margin: 0 18px;
          }
        }
        &.no-padding {
          padding: 0;
        }
        .box {
          margin-top: 24px;
        }
        .luckyDraw {
          // margin: 24px 0 0 0;
          
          // background: linear-gradient( 180deg, #FFFFFF 0%, #FFFFFF 66%, #FFFFFF 100%);
          border-radius: 8px;
          .prize-header {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            margin: 55px 0 28px 0;
            img{
              width: 32px !important;
              height: 32px;
            }
            .text{
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 30px;
              color: #979797;
              text-align: center;
              font-style: normal;
              margin: -5px 40px 0;
            }
            .prize-text{
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 30px;
              color: #A52337;
              text-align: center;
              font-style: normal;
              margin: -5px 40px 0;
            }
          }
          .body {
            height: 128px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 44px;
              .text {
                font-family: "D-DIN-PRO-500-Medium";
                font-weight: 500;
                font-size: 28px;
                color: #ACACAC;
                text-align: center;
                font-style: normal;
                
              }
              .text-five {
                display: flex;
                flex-direction: column;
                font-family: "D-DIN-PRO-500-Medium";
                font-weight: 500;
                font-size: 56px;
                color: #A52337;
                text-align: center;
                width: 366px;
                height: 128px;
                line-height: 128px;
                background-size: 366px 128px;
                background-image: url("https://cdn-arch-common-prod.cotticoffee.com/cottih5/lottery-one-code.png");
                .prize-code-text {
                  font-size: 24px;
                  height: 20px !important;
                  line-height: 60px;
                }
              }
              .text-six {
                display: flex;
                flex-direction: column;
                font-family: "D-DIN-PRO-500-Medium";
                font-weight: 500;
                font-size: 56px;
                color: #ffffff;
                text-align: center;
                width: 366px;
                height: 128px;
                line-height: 128px;
                background-size: 366px 128px;
                background-image: url("https://cdn-arch-common-prod.cotticoffee.com/cottih5/lottery-only-prize.png");
                .prize-code-text {
                  font-size: 24px;
                  height: 20px !important;
                  line-height: 60px;
                }
              }
              .text-seven {
                display: flex;
                flex-direction: column;
                font-family: "D-DIN-PRO-500-Medium";
                font-weight: 500;
                font-size: 56px;
                color: #ACACAC;
                text-align: center;
                width: 366px;
                height: 128px;
                line-height: 128px;
                background-size: 366px 128px;
                background-image: url("https://cdn-arch-common-prod.cotticoffee.com/cottih5/lottery-only-no-prize.png");
                .prize-code-text {
                  font-size: 24px;
                  height: 20px;
                  line-height: 60px;
                }
              }
              flex-direction: column;
              // background-image: '../../assets/pointsActivity/luckyTipBg.png';
              // width: 300px;
              // height: 124px;
            }
            img {
              width: 700px;
              pointer-events:none;
            }
            .card {
              position: relative;
              z-index: 9;
              margin: 32px 24px 0 24px;
              // width: 640px;
              height: 158px;
              background-color: rgba(255,255,255,0.6);
              border-radius: 4px;
              display: flex;
              flex-direction: row;
              padding: 16px;
              border-radius: 8px;
              img {
                width: 208px;
                margin-right: 16px;
                pointer-events:none;
                // padding: 16px;
              }
              .prize {
                display: flex;
                flex-direction: column;
                // justify-content:flex-start;
                align-items:flex-start;
                .title {
                font-weight: 600;
                font-size: 26px;
                color: #3A3B3C;
                line-height: 32px;
                text-align: left;
              }
              .context {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 22px;
                color: #ACACAC;
                line-height: 32px;
                text-align:start;
              }
              }
            }
            .bottom {
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 26px;
              color: #ACACAC;
              text-align: center;
              margin: 0 50px 10px 50px;
              padding-bottom: 24px;
            }
          }
          .luckyDraw-6 {
            // padding: 16px 0;
            // margin-top: 0;
            // background: linear-gradient( 180deg, #FFE8EA 0%, #FFF4F5 50%, #FFFFFF 60%, #FFFFFF 100%);
           }
        
        .lottery-btn-before {
          margin-left: 18px;
          height: 128px;
          width: 128px;
          background: linear-gradient( 135deg, #DADADA 0%, #D2D2D2 100%);
          opacity: 0.4;
          background-image: url("https://cdn-arch-common-prod.cotticoffee.com/cottih5/lottery-btn.png");
          background-size: 100% 100%;
          z-index: 999;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;

          &.disable {
            // margin: 0 auto;
            background: linear-gradient( 135deg, #DADADA 0%, #D2D2D2 100%);;
          }
         
          .text {
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            text-align: center;
            // line-height: 56px;
            white-space: pre;
          }
        }
        .lottery-btn {
          height: 168px;
          width: 168px;
          background-image: url("https://cdn-arch-common-prod.cotticoffee.com/cottih5/lottery-btn.png");
          background-size: 100% 100%;
          z-index: 999;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;

          &.disable {
            // margin: 0 auto;
            background: linear-gradient( 135deg, #DADADA 0%, #D2D2D2 100%);;
          }
         
          .text-login{
            font-size: 24px !important;
          }
          .text {
            font-size: 24px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            text-align: center;
            // line-height: 56px;
            white-space: pre;
          }
          .text1 {
            font-size: 24px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            text-align: center;
            // line-height: 56px;
            white-space: pre;
            display: flex;
            flex-direction: row;
            img {
              width: 24px;
              margin-left: 4px;
              pointer-events:none;
            }
          }
          .text2 {
            margin-top: 8px;
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            text-align: center;
            // line-height: 56px;
            white-space: pre;
          }
          img {
            width: 24px;
            height: 24px;
            margin-left: 8px;
            margin-top: 1px;
            pointer-events:none;
          }
          

          .icon {
            width: 44px;
            height: 44px;
          }
        }
        @keyframes grow {
          0% {
            transform: translate(-50%, -50%) scale(1.7);
          }
          50% {
            transform: translate(-50%, -50%) scale(2);
          }
          100% {
            transform: translate(-50%, -50%) scale(1.7);
          }
        }
        .lottery-btn-border {
          width: 93px;
          height: 93px;
          opacity: 0.4;
          z-index: 1;
          background: linear-gradient( 135deg, rgba(255,174,172,0.53) 0%, #FF2525 100%);
          border-radius: 50%; /* 圆形形状 */
          position: absolute; /* 绝对定位 */
          top: 50%; /* 定位到中心点的垂直位置 */
          left: 50%; /* 定位到中心点的水平位置 */
          transform: translate(-50%, -50%); /* 用来调整定位的偏移 */
          animation: grow 2s infinite; /* 应用动画 */
        }
        /* 呼吸效果的关键帧动画 */

        .bg-ticket {
          width: 100%;
          height: auto;
          border-radius: 0 0 16px 16px;
        }

        .ticket-code {
          position: absolute;
          left: 0;
          right: 0;
          top: 50%;
          text-align: center;
          height: 56px;
          font-size: 56px;
          font-family: "D-DIN-PRO-500-Medium";
          font-weight: 500;
          color: #A52337;
          line-height: 56px;

          &.normal {
            color: #A52337;
          }

          &.winning {
            top: 55%;
            color: #fff;
          }

          &.losing {
            top: 55%;
            color: #979797;
          }
        }
      }
    }

    .nolotteryCode {
      width: 100%;
      background: #F5F6F7;
      border-radius: 0 0 8px 8px;
      padding-bottom: 40px;

      .nolotteryCode-text {
        font-size: 32px;
        text-align: center;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #979797;
        padding: 24px 0;
        background-image: url("../../../assets/pointsActivity/onlottery-up.png");
        background-size: 100% 100%;
      }

      .nolotteryCode-cardbox {
        width: 100%;
        position: relative;

        img {
          display: block;
          margin: auto;
          height: 124px;
          width: 300px;
          pointer-events:none;
        }

        .nolotteryCode-num {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;

          .box {
            width: 100%;
            height: calc(100% - 24px);
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-flow: column;
            padding: 12px 0;

            .top {
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #979797;
            }

            .num {
              font-size: 56px;
              font-family: "D-DIN-PRO-500-Medium";
              font-weight: 500;
              color: #979797;
            }
          }
        }
      }
    }

    .lottery {
      width: 100%;
      background: linear-gradient(to bottom, #fff, #FEEAE8, #FFDADA);
      border-radius: 0 0 8px 8px;
      padding-bottom: 40px;

      .lottery-text {
        font-size: 32px;
        text-align: center;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #A52337;
        padding: 24px 0;
        background-image: url("../../../assets/pointsActivity/lottery-up.png");
        background-size: 100% 100%;
      }

      .lottery-cardbox {
        width: 100%;
        position: relative;

        img {
          display: block;
          margin: auto;
          height: 124px;
          width: 440px;
          pointer-events:none;
        }

        .lottery-num {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;

          .box {
            width: 100%;
            height: calc(100% - 24px);
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-flow: column;
            padding: 12px 0;

            .top {
              font-size: 24px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #fff;
            }

            .num {
              font-size: 56px;
              font-family: "D-DIN-PRO-500-Medium";
              font-weight: 500;
              color: #fff;
            }
          }
        }
      }
    }

    // .history-list {
    //   // display: flex;
    //   // justify-content: space-between;
    //   // width: 100%;
    //   // height: 96px;
    //   border-radius: 6px;
    //   margin-bottom: 24px;
    // }

    .history-list:last-child {
      margin-bottom: 0;
    }

    .qualify {
      background: #F5F6F7;

      .history-data {
        display: flex;
        align-items: center;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #3A3B3C;
        flex-direction: column;

         img {
          width: 40px;
          height: 40px;
          margin: 0 16px 0 24px;
          pointer-events:none;
        }
        

        div {
          margin-top: 3px;
        }

      }


      .history-num {
        display: flex;
        align-items: center;

        div {
          font-size: 32px;
          font-family: "D-DIN-PRO-500-Medium";
          font-weight: 500;
          color: #A52337;
        }

        .start {
          width: 32px;
          height: 32px;
          margin: 0 8px 0 6px;
        }

        .arrow {
          width: 40px;
          height: 40px;
          margin-right: 16px;
        }

      }
    }

    .history-more-list{
      display: flex;
      // position: absolute
      overflow: auto;
      .no-qualify {
      .history-data {
        display: flex;
        align-items: center;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #909191;
        // flex-direction:column;
        justify-content:space-between;

        .history {
          width: 240px;
          height: 320px;
          margin: 0 16px 0 24px;
          pointer-events:none;
          // background: url("../../assets//pointsActivity/get-prize.png");
        }
        .history-more {
          width: 654px;
          height: 276px;

          // margin: 0 16px 0 24px;
        }
        .get-prize {
          width: 112px;
          height: 112px;
          position: absolute;
          // top: 100px;
        }
        .tip-history {
          position: absolute;
          top: 110px;
          margin-left:160px;
          color: #FFFFFF;
          padding: 2px 12px;
          height: 32px;
          line-height: 32px;
          text-align: center;
          font-size: 20px;
          font-weight: 500;
          background: rgba(0,0,0,0.5);
          border-radius: 8px;
          font-family: "D-DIN-PRO-500-Medium";
        }
        .tip-history-more {
          position: absolute;
          top: 110px;
          right: 40px;
          color: #FFFFFF;
          padding: 2px 12px;
          height: 32px;
          line-height: 32px;
          text-align: center;
          font-size: 20px;
          font-weight: 500;
          background: rgba(0,0,0,0.5);
          border-radius: 8px;
          font-family: "D-DIN-PRO-500-Medium";
        }

        div {
          margin-top: 3px;
        }

      }
      .history-num {
        display: flex;
        align-items: center;

        div {
          color: #E08F8F;
          font-size: 32px;
          font-family: "D-DIN-PRO-500-Medium";
          font-weight: 500;
        }

        .start {
          width: 32px;
          height: 32px;
          margin: 0 8px 0 6px;
          background: #FFFFFF;
          opacity: .4;
        }

        .arrow {
          width: 40px;
          height: 40px;
          margin-right: 16px;
          background: #FFFFFF;
          opacity: .4;
        }

      }
    }
    }
  }

  .lottery-ticket {
    width: 300px;
    height: 124px;
    margin: 0 auto 40px;
    background: url("~@/assets/pointsActivity/bg_ticket.png") no-repeat;
    background-size: 100% 100%;

    .code {
      padding-top: 18px;
      text-align: center;
      font-size: 56px;
      font-family: "D-DIN-PRO-500-Medium";
      font-weight: 500;
      color: #A52337;
      line-height: 56px;
    }
  }

  .lottery-Exchang {
    text-align: center;

    .top {
      display: flex;
      align-items: center;
      justify-content: center;

      div {
        font-size: 26px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #3A3B3C;
      }

      span {
        font-size: 36px;
        font-family: D-DIN-PRO-Medium, D-DIN-PRO;
        font-weight: 500;
        color: #A52337;
        margin-left: 8px;
      }

      img {
        width: 26px;
        height: 26px;
        margin: 0 4px;
        pointer-events:none;
      }
    }

    .down {
      color: #A52337;
      margin: 16px 0 24px 0;
    }
  }

}
</style>
